export default {
  PASSWORD: {
    REGEX: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^*+=-])[A-Za-z\d!@#$%^*+=-]{8,16}$/,
    MSG: '비밀번호는 영문, 숫자, 특수문자(!@#$%^*+=-) 조합 8~15자로 입력해주세요.',
  },
  PHONE: {
    REGEX: /^01\d{9}$/,
    MSG: '휴대폰 번호가 유효하지 않습니다.',
  },
  EMAIL: {
    REGEX: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
    MSG: '이메일 주소가 유효하지 않습니다.',
  },
  LICENSENUMBER: {
    REGEX: /^[0-9].{9}$/,
    MSG: '사업자등록번호가 유효하지 않습니다.',
  },
  URL: {
    // REGEX: /^(file|gopher|news|nntp|telnet|https?|ftps?|sftp):\/\/([a-z0-9-]+\.)+[a-z0-9]{2,4}.*$/,
    REGEX:
      /^((file|gopher|news|nntp|telnet|https?|ftps?|sftp):\/\/)|([a-zA-Z0-9-])+\.+[a-zA-Z0-9]{2,4}.*$/,
    MSG: '쇼핑몰 URL이 유효하지 않습니다.',
  },
  NUMBERIC: {
    REGEX: /^[0-9]+$/,
    MSG: '숫자만 입력해주세요',
  },
}
